<template>
<v-app dark>
  <v-main>
    <v-container fill-height fluid>
      <v-layout align-center justify-center>
        <v-flex class="login-form text-xs-center">
          <div class="display-1 mb-3">
            <h3 class="font-weight-regular text-center">
                سیستم حسابداری کیان
            </h3>
          </div>
          <v-card light>
            <v-card-text>
              <div class="subheading">
                <template>اطلاعات کاربری خود را وارد کنید</template>
              </div>
              <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onLogin">
                <!-- <v-text-field required :rules="requiredRules" v-model="username" light prepend-icon="mdi-account" label="نام کاربری" type="text" ref="username"></v-text-field> -->
                <!-- <v-text-field required :rules="requiredRules" v-model="password" light prepend-icon="mdi-lock" label="رمز عبور" type="password"></v-text-field> -->
                <v-text-field v-model="username" light prepend-icon="mdi-account" :rules="[rules.required]" label="نام کاربری" type="text" ref="username"></v-text-field>
                <v-text-field v-model="password" prepend-icon="mdi-lock" :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" :rules="[rules.required]" :type="show ? 'text' : 'password'" name="input-10-1" label="کلمه عبور" hint="حداقل 6 کاراکتر" counter
                  @click:append="show = !show">
                </v-text-field>
                <br/>
                <v-btn class="primary" tile block type="submit">ورود</v-btn>
              </v-form>
            </v-card-text>
          </v-card>
          <br/>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
  <v-footer app>
    <v-flex class="text-center">© 2024. تمامی حقوق محفوظ است.</v-flex>
  </v-footer>

</v-app>
</template>

<script>
export default {
  name: 'LogIn',
  data() {
    return {
      show: false,
      valid: false,
      username: null,
      password: null,
      rules: {
        required: value => !!value || 'اجباری',
        min: v => v && v.length >= 6 || 'حداقل 6 کاراکتر',
      },
      requiredRules: [
        v => !!v || 'فیلد اجباری',
      ],
    }
  },
  methods: {
    async onLogin() {
      this.$refs.form.validate()
      if (this.valid) {
        this.$store.dispatch('login', {
          username: this.username,
          password: this.password
        })
      }
    },
  },
  // computed: {
  //   user() {
  //     return this.$store.getters.user
  //   }
  // },
  // watch: {
  //   user(value) {
  //     // console.log(value);
  //     if (value !== null && value !== undefined) {
  //       this.$router.push('/')
  //     }
  //   }
  // },
  created() {

  },
  mounted() {
    document.title = 'حسابداری کیان - ورود';
    this.$refs.username.focus()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.login-form {
    max-width: 500px;
}
</style>
